import { ReactElement } from 'react';
import { Skeleton } from 'newcomponents/UI/Skeleton';

export const SingleGameSkeleton = ({
  withMargin
}: {
  withMargin?: boolean;
}): ReactElement => {
  return (
    <div
      className="SingleGameSkeleton"
      style={{
        borderTop: withMargin ? '2px solid var(--v3-black-6)' : 'initial'
      }}
    >
      <Skeleton
        title={{
          style: { width: '30%', margin: '5px 0', height: 10 }
        }}
        paragraph={false}
        active
      />
      <Skeleton
        title={{
          style: { width: '20%', margin: '5px 0', height: 8 }
        }}
        paragraph={false}
        active
      />
      <Skeleton
        title={{
          style: { width: '40%', margin: '5px 0', height: 10 }
        }}
        paragraph={false}
        active
      />
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <Skeleton
          title={{
            style: { width: '30%', margin: '5px 0', height: 8 }
          }}
          paragraph={false}
          active
        />
        <Skeleton
          title={{
            style: { width: '30%', margin: '5px 0', height: 8 }
          }}
          paragraph={false}
          active
        />
      </div>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <Skeleton
          title={{
            style: { width: '30%', margin: '5px 0', height: 8 }
          }}
          paragraph={false}
          active
        />
        <Skeleton
          title={{
            style: { width: '30%', margin: '5px 0', height: 8 }
          }}
          paragraph={false}
          active
        />
      </div>
    </div>
  );
};
